import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  justify-content: row;
  align-items: center;
`;

export const Column = styled.div`
  display: flex;
  justify-content: column;
`;
